export default {
    'add-a-record': 'Add a record',
    'the-employee-is-balance-is-being-prepared-for-the-day': 'The employee is balance is being prepared for the day.',
    'non-matching-records': 'Non-matching records',
    "total-amount-received": "Total amount received",
    "total-amount-delivered": "Total amount delivered",
    "are-you-sure-you-want-to-migrate-this-journal": "Are you sure you want to migrate this journal?"
}